<template>
  <a-dropdown placement="bottomRight">
    <span class="ant-pro-account-avatar">
      <a-avatar size="small" src="https://gw.alipayobjects.com/zos/antfincdn/XAosXuNZyF/BiazfanxmamNRoxxVxka.png"
                class="antd-pro-global-header-index-avatar"/>
      <span>{{ userName }}</span>
    </span>
    <template v-slot:overlay>
      <a-menu
        class="ant-pro-drop-down menu" :selected-keys="[]">
        <a-menu-item v-if="menu" key="settings" @click="handleToSettings">
          <a-icon type="setting"/>
          {{ $t('USER_SETTING') || '用户设置' }}
        </a-menu-item>
        <a-menu-divider v-if="menu"/>
        <a-menu-item key="logout" @click="handleLogout">
          <a-icon type="logout"/>
          {{ $t('LOGOUT' || '推出登录') }}
        </a-menu-item>
      </a-menu>
    </template>
  </a-dropdown>
</template>

<script>
import { Modal } from 'ant-design-vue';

export default {
  name: 'AvatarDropdown',
  data() {
    return {
      userName: this.$store.getters.getUserName(),
    };
  },
  props: {
    currentUser: {
      type: Object,
      default: () => null,
    },
    menu: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    handleToCenter() {
      this.$router.push({ path: '/account/center' });
    },
    handleToSettings() {
      this.$router.push({ path: '/account/settings' });
    },
    handleLogout() {
      Modal.confirm({
        title: this.$t('layouts.usermenu.dialog.title'),
        content: this.$t('layouts.usermenu.dialog.content'),
        onOk: () => {
          this.$store.commit('clearLoginInfo');
          this.$router.push({ path: 'login' });
        },
        onCancel() {
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.ant-pro-drop-down {
  /deep/ .action {
    margin-right: 8px;
  }

  /deep/ .ant-dropdown-menu-item {
    min-width: 160px;
  }
}
</style>
